import { useState } from 'react';
import { Form, Input, Button, Checkbox, Layout, Typography, Row, Col } from 'antd';
import { useNavigate } from "react-router-dom";

import { signIn } from '../../Services/firebase/auth';
const { Content } = Layout;
const { Text } = Typography;

const Login = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const onFinish = (values) => {
    signIn(values.email, values.password)
      .then((userCredential) => {
        const user = userCredential.user;
        localStorage.setItem("user", JSON.stringify(user));
        navigate('/', { replace: true });
      })
      .catch((err) => {
        localStorage.clear();
        setError(err)
      });
  };

  return (
    <Layout className="site-layout" style={{ minHeight: '100vh' }}>
      <Content className='login'>
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          autoComplete="off"
          style={{ width: '400px' }}
        >
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: true,
                message: 'Please input your email!',
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[
              {
                required: true,
                message: 'Please input your password!',
              },
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            name="remember"
            valuePropName="checked"
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Checkbox>Remember me</Checkbox>
          </Form.Item>
          {error && (
            <Row>
              <Col span={24} offset={8}>
                <Text type="danger">Incorrect email address or password</Text>
              </Col>
            </Row>
          )}

          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Content>
    </Layout >
  );
};

export default Login;